module.exports = __webpack_public_path__ + "1dbda55ceec3e20da6267d197f786f4b.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/amplification/paid-ig.png
// module id = 3284
// module chunks = 69